import { ZodSchema } from 'zod'

import { validateByScheme } from '../validation'
import { Parser } from './LocalStorage'

export type CreateParserOptions = {
  onValidationError?: (error?: Error) => void
}

export function createLsParser<TValue>(
  schema: ZodSchema | null,
  options: CreateParserOptions = {},
): Parser<TValue> {
  return (input) => {
    if (!input) return null

    const parsed = JSON.parse(input)

    const { success, data, error } = validateByScheme<TValue>(parsed, schema)

    if (!success) {
      options.onValidationError?.(error)
      return null
    }

    return data
  }
}
